<template>
  <v-container grid-list-lg>
    <v-layout row wrap justify-center align-center>
      <v-flex xl8 lg10 md12 xs12>
        <v-card flat id="pluma" class="transparent" height="100"></v-card>
        <v-layout row wrap justify-center>
          <v-flex sm6 xs12>
            <h1 class="mb-3 primary--text">
              {{ trans('Cyber Defence Academy') }}
            </h1>

            <p class="mb-4"><strong>{{ __('CDA supports corporate learning and development through its cloud learning platform called Pluma based on a pedagogy called PEbAAL, which stands for performance-based, experiential, adaptive and agile learning.') }}</strong></p>

            <v-card flat class="mb-3 transparent">
              <v-card-text class="text-xs-center">
                <v-img @contextmenu.prevent="preventRightClick" width="80" :src="security" alt=""></v-img>
              </v-card-text>
            </v-card>

            <p>{{ __('The principal training coordinator at CDA is Zaid Hamzah, technology lawyer, author, and Adjunct Senior Fellow at the S. Rajaratnam School of International Studies, Nanyang Technological University.') }}</p>

            <p>{{ __('CDA also provides consultancy services to companies, organisations, and governments in the following areas:') }}</p>
            <ul>
              <li>{{ __('Cybersecurity policy design and development') }}</li>
              <li>{{ __('Cybersecurity GRC (governance, risk and compliance) design and development') }}</li>
              <li>{{ __('Cybersecurity audit and performance measurement') }}</li>
            </ul>
          </v-flex>

          <v-flex sm5 offset-sm1 xs12>
            <areas></areas>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import security from '@/modules/CDA/About/assets/images/security.svg'
import Areas from './Areas'

export default {
  name: 'Pluma',

  components: {
    Areas,
  },

  data () {
    return {
      security: security,
    }
  },

  mounted () {
    this.preventRightClick()
  },

  methods: {
    preventRightClick () {
      return false
    }
  }
}
</script>
